import React from "react";
import {
  BookForm,
  BookRide,
  PlanTrip,
  RentalFleet,
  Save,
  ChooseUs,
  HomeTestimonials,
  Faq,
  DownloadApp,
  Footer,
} from "../../Components/HomePage/Import";

const MainPage = () => {
  return (
    <>
      <BookRide />
      <BookForm />
      <PlanTrip />
      <RentalFleet />
      <Save />
      <ChooseUs />
      <HomeTestimonials />
      <Faq />
      <DownloadApp />
      <Footer />
    </>
  );
};

export default MainPage;
